import { Alert, AlertTitle } from "@mui/material"
import { ErrorOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

export const ProductsMultipleShipingLocationsAlert: FC = () => {
  return (
    <Alert severity='error' icon={<ErrorOutlined />}>
      <AlertTitle>You have selected products from more than one “Ship From” location</AlertTitle>
      Please review checked Items before placing the order or filter by location in order to view items shipped from one
      specific Ship From location.
    </Alert>
  )
}
